import { render, staticRenderFns } from "./XtendProbeMetricsTab.vue?vue&type=template&id=64484c70&"
import script from "./XtendProbeMetricsTab.vue?vue&type=script&lang=js&"
export * from "./XtendProbeMetricsTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports